var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 133,
    height: 93,
    viewBox: "0 0 133 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2164_1266)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.0044 91.5339L2.54847 72.2871C0.864577 71.3173 0.0226329 70.0228 0 68.6651C0 68.5433 0.00452658 67.5104 0.0135797 67.3886C0.153904 65.8144 1.36703 66.6804 3.60316 65.3949L82.2751 20.1353C86.6342 17.6274 93.2249 17.3568 97.0001 19.5264L130.456 38.7732C132.14 39.743 132.977 38.038 133.005 39.3957C133.005 39.5129 133.005 41.0511 132.991 41.1728C132.855 42.747 131.642 44.3799 129.397 45.6699L50.7249 90.9295C46.3703 93.4329 39.7751 93.708 36.0044 91.5339Z",
    fill: "url(#paint0_linear_2164_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2751 20C86.6342 17.4921 93.2249 17.2215 97.0001 19.3911L130.456 38.6379C132.113 39.5897 132.891 38.0019 132.986 39.3326C132.995 39.4724 133.005 40.9654 132.991 41.1052C132.86 42.684 131.642 44.3123 129.397 45.6068L50.7249 90.8664C46.3658 93.3743 39.7751 93.645 35.9999 91.4754L2.54847 72.2285C0.855524 71.2542 0.0135797 69.9552 0 68.593C0 68.4577 0.0135797 67.4518 0.0271595 67.3165C0.217276 65.7648 1.38966 66.5361 3.60316 65.2641L82.2751 20Z",
    fill: "url(#paint1_linear_2164_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2751 19.8645C86.6342 17.3566 93.2249 17.086 97.0001 19.2556L130.456 38.5024C132.081 39.4361 132.823 37.9702 132.968 39.2692C132.986 39.4316 133.005 40.875 132.991 41.0419C132.864 42.6206 131.647 44.2535 129.397 45.548L50.7249 90.8076C46.3658 93.3155 39.7751 93.5861 35.9999 91.4165L2.54847 72.1652C0.850997 71.1909 0.00452658 69.8828 0 68.5161C0 68.3673 0.0226329 67.3885 0.0452658 67.2396C0.271595 65.715 1.42135 66.3826 3.60768 65.1241L82.2751 19.8645Z",
    fill: "url(#paint2_linear_2164_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2785 19.7293C86.6376 17.2214 93.2283 16.9507 97.0035 19.1204L130.459 38.3672C132.053 39.2828 132.772 37.9387 132.954 39.2062C132.981 39.3911 133.008 40.7894 132.994 40.9743C132.872 42.553 131.65 44.1904 129.4 45.4849L50.7282 90.7445C46.3691 93.2524 39.7784 93.5231 36.0033 91.3535L2.55182 72.1066C0.849828 71.1278 -0.00116919 69.8152 0.00788397 68.444C0.00788397 68.2816 0.0350435 67.3299 0.0667295 67.163C0.329271 65.661 1.45639 66.2293 3.61104 64.9889L82.2785 19.7293Z",
    fill: "url(#paint3_linear_2164_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2787 19.594C86.6378 17.0861 93.2285 16.8155 97.0037 18.9851L130.46 38.2319C132.026 39.1341 132.723 37.9072 132.936 39.1431C132.972 39.3506 133.013 40.6992 132.995 40.9112C132.877 42.4945 131.655 44.1318 129.4 45.4264L50.7284 90.686C46.3693 93.1939 39.7786 93.4645 36.0035 91.2949L2.55203 72.0435C0.845512 71.0602 -0.0100124 69.7431 0.00809397 68.3674C0.00809397 68.187 0.0443066 67.2668 0.0805193 67.0864C0.37022 65.6024 1.48376 66.076 3.61125 64.8491L82.2787 19.594Z",
    fill: "url(#paint4_linear_2164_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2789 19.4588C86.638 16.9509 93.2287 16.6802 97.0038 18.8499L130.46 38.0967C131.994 38.9808 132.682 37.8711 132.918 39.08C132.963 39.3055 133.013 40.6136 132.995 40.8436C132.877 42.4269 131.655 44.0642 129.401 45.3633L50.7286 90.6229C46.3695 93.1308 39.7788 93.4014 36.0036 91.2318L2.55219 71.985C0.836617 70.9971 -0.0143806 69.6755 0.00825228 68.2953C0.0127789 68.1013 0.0535181 67.2127 0.0987839 67.0143C0.411118 65.5528 1.51108 65.9272 3.61141 64.7184L82.2789 19.4588Z",
    fill: "url(#paint5_linear_2164_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2793 19.3233C86.6384 16.8154 93.2291 16.5447 97.0042 18.7144L130.46 37.9612C131.968 38.8272 132.647 37.8394 132.905 39.0167C132.959 39.2647 133.018 40.5277 133 40.7803C132.886 42.3635 131.66 44.0054 129.405 45.3045L50.729 90.564C46.3699 93.072 39.7792 93.3426 36.004 91.173L2.5526 71.9216C0.832499 70.9338 -0.0230247 69.6077 0.00866136 68.2184C0.0131879 68.0109 0.0629803 67.1494 0.112773 66.9329C0.44774 65.494 1.53865 65.7692 3.61182 64.5784L82.2793 19.3233Z",
    fill: "url(#paint6_linear_2164_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2717 19.1836C86.6308 16.6757 93.2215 16.4051 96.9967 18.5747L130.453 37.8215C131.928 38.6695 132.603 37.799 132.879 38.9492C132.942 39.2198 133.01 40.4332 132.992 40.7128C132.879 42.3006 131.657 43.9424 129.398 45.2415L50.7214 90.5011C46.3623 93.009 39.7716 93.2796 35.9965 91.11L2.54504 71.8632C0.820414 70.8709 -0.0351095 69.5402 0.00110311 68.1464C0.00562969 67.9209 0.0644753 67.091 0.118794 66.8609C0.471868 65.4446 1.55825 65.6205 3.59973 64.4432L82.2717 19.1836Z",
    fill: "url(#paint7_linear_2164_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.272 19.0481C86.6311 16.5402 93.2218 16.2696 96.997 18.4392L130.453 37.686C131.897 38.516 132.571 37.7672 132.861 38.8859C132.938 39.179 133.01 40.3473 132.992 40.645C132.884 42.2327 131.657 43.8791 129.398 45.1782L50.7217 90.4423C46.3626 92.9502 39.7719 93.2208 35.9968 91.0512L2.54533 71.7999C0.816174 70.803 -0.0393501 69.4679 0.0013891 68.0696C0.0104423 67.8305 0.0692878 67.0276 0.137187 66.7841C0.50384 65.3858 1.58569 65.467 3.60455 64.3077L82.272 19.0481Z",
    fill: "url(#paint8_linear_2164_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2723 18.9129C86.6314 16.405 93.2221 16.1343 96.9973 18.304L130.453 37.5508C131.87 38.3672 132.54 37.7312 132.843 38.8228C132.929 39.1385 133.015 40.2572 132.993 40.5819C132.884 42.1697 131.662 43.816 129.399 45.1196L50.722 90.3792C46.363 92.8871 39.7723 93.1577 35.9971 90.9881L2.54565 71.7413C0.807446 70.7444 -0.043551 69.4003 0.00171476 67.9975C0.0107679 67.7449 0.0786666 66.9691 0.151092 66.7074C0.535851 65.3317 1.61318 65.3137 3.60487 64.1725L82.2723 18.9129Z",
    fill: "url(#paint9_linear_2164_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2727 18.7776C86.6318 16.2697 93.2225 15.9991 96.9976 18.1687L130.454 37.4155C131.839 38.2139 132.513 37.6952 132.826 38.7597C132.925 39.098 133.016 40.1715 132.993 40.5143C132.884 42.1021 131.662 43.7529 129.399 45.0565L50.7224 90.3206C46.3633 92.8285 39.7726 93.0992 35.9974 90.9295L2.546 71.6782C0.803269 70.6769 -0.0477279 69.3282 0.00206445 67.9209C0.0111176 67.6502 0.0835429 66.906 0.165021 66.6308C0.56336 65.2731 1.64069 65.1649 3.6007 64.0327L82.2727 18.7776Z",
    fill: "url(#paint10_linear_2164_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.273 18.6424C86.6321 16.1345 93.2228 15.8638 96.998 18.0334L130.454 37.2803C131.812 38.0606 132.486 37.6592 132.808 38.6966C132.921 39.0575 133.016 40.0814 132.993 40.4512C132.889 42.0435 131.667 43.6944 129.399 44.9979L50.7228 90.2575C46.3637 92.7654 39.773 93.0361 35.9978 90.8665L2.54638 71.6196C0.799123 70.6138 -0.0518744 69.2606 0.0024446 67.8488C0.0114978 67.5646 0.0929762 66.8474 0.183508 66.5587C0.595427 65.2191 1.66823 65.0161 3.6056 63.902L82.273 18.6424Z",
    fill: "url(#paint11_linear_2164_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2735 18.5069C86.6326 15.999 93.2233 15.7283 96.9984 17.8979L130.454 37.1448C131.781 37.9071 132.46 37.6229 132.79 38.6333C132.917 39.0122 133.016 39.9955 132.994 40.3834C132.89 41.9756 131.667 43.631 129.4 44.9346L50.7232 90.1987C46.3641 92.7066 39.7734 92.9772 35.9982 90.8076L2.54679 71.5563C0.795006 70.5459 -0.0559908 69.1882 0.00285475 67.7719C0.0164345 67.4742 0.097913 66.7841 0.197498 66.4819C0.61847 65.1602 1.6958 64.8625 3.60149 63.7665L82.2735 18.5069Z",
    fill: "url(#paint12_linear_2164_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2739 18.3672C86.633 15.8593 93.2237 15.5887 96.9989 17.7583L130.455 37.0051C131.749 37.7494 132.433 37.5825 132.772 38.5658C132.913 38.9672 133.017 39.9009 132.99 40.3159C132.886 41.9082 131.663 43.5681 129.391 44.8716L50.7236 90.1357C46.3646 92.6436 39.7738 92.9143 35.9987 90.7447L2.54725 71.4978C0.786409 70.4875 -0.0600618 69.1208 0.00331029 67.6999C0.01689 67.3842 0.107422 66.7256 0.211533 66.4054C0.646085 65.1063 1.72341 64.7094 3.60194 63.6268L82.2739 18.3672Z",
    fill: "url(#paint13_linear_2164_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2744 18.2317C86.6335 15.7238 93.2242 15.4532 96.9994 17.6228L130.455 36.8696C131.723 37.6003 132.411 37.5417 132.759 38.507C132.913 38.931 133.026 39.8196 132.995 40.2526C132.895 41.8493 131.673 43.5047 129.396 44.8128L50.7241 90.0769C46.365 92.5848 39.7743 92.8555 35.9992 90.6859L2.54772 71.4345C0.782353 70.4196 -0.0641175 69.0484 0.00378126 67.623C0.0218876 67.2938 0.112419 66.6623 0.23011 66.3285C0.673715 65.0475 1.75557 64.5558 3.60694 63.4913L82.2744 18.2317Z",
    fill: "url(#paint14_linear_2164_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2749 18.0965C86.634 15.5886 93.2247 15.3179 96.9998 17.4875L130.456 36.7344C131.692 37.4471 132.384 37.5057 132.742 38.4439C132.909 38.8859 133.027 39.7294 132.995 40.1895C132.896 41.7863 131.673 43.4462 129.397 44.7543L50.7246 90.0138C46.3655 92.5217 39.7748 92.7924 35.9996 90.6228L2.54822 71.376C0.778326 70.3566 -0.0681443 68.9808 0.00428102 67.5509C0.0223873 67.2081 0.117446 66.6037 0.24419 66.2564C0.701374 64.9934 1.7787 64.407 3.60291 63.3606L82.2749 18.0965Z",
    fill: "url(#paint15_linear_2164_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2754 17.9612C86.6345 15.4533 93.2252 15.1827 97.0004 17.3523L130.456 36.5991C131.665 37.2938 132.362 37.4652 132.724 38.3808C132.91 38.8409 133.027 39.6438 132.996 40.1219C132.896 41.7187 131.679 43.3831 129.397 44.6912L50.7251 89.9553C46.3661 92.4632 39.7753 92.7338 36.0002 90.5642L2.54875 71.3129C0.774328 70.289 -0.0721427 68.9087 0.00480916 67.4743C0.0229155 67.118 0.1225 66.5406 0.258298 66.1753C0.724536 64.9258 1.80639 64.2492 3.60344 63.2163L82.2754 17.9612Z",
    fill: "url(#paint16_linear_2164_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2793 17.826C86.6384 15.3181 93.2291 15.0474 97.0043 17.217L130.46 36.4639C131.637 37.1405 132.339 37.4291 132.71 38.3177C132.909 38.8004 133.031 39.5536 133 40.0588C132.9 41.6601 131.682 43.3245 129.401 44.6326L50.729 89.8922C46.3699 92.4001 39.7792 92.6707 36.0041 90.5011L2.55264 71.2543C0.769168 70.2304 -0.0682498 68.8411 0.0132287 67.4022C0.0358616 67.0278 0.135446 66.4821 0.284824 66.1032C0.760114 64.8718 1.84649 64.1004 3.61186 63.0856L82.2793 17.826Z",
    fill: "url(#paint17_linear_2164_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2721 17.6905C86.6312 15.1826 93.2219 14.9119 96.9971 17.0815L130.453 36.3284C131.598 36.9869 132.309 37.3884 132.685 38.2544C132.902 38.7551 133.024 39.4678 132.992 39.9955C132.893 41.5968 131.675 43.2612 129.394 44.5738L50.7218 89.8334C46.3627 92.3413 39.772 92.6119 35.9968 90.4423L2.54542 71.191C0.757417 70.1625 -0.0800001 68.7688 0.00600496 67.3254C0.0286379 66.9374 0.132749 66.4187 0.29118 66.0263C0.775524 64.8129 1.8619 63.9514 3.60464 62.9501L82.2721 17.6905Z",
    fill: "url(#paint18_linear_2164_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2727 17.5508C86.6318 15.0429 93.2225 14.7723 96.9977 16.9419L130.454 36.1887C131.572 36.8292 132.282 37.3434 132.667 38.1869C132.903 38.7056 133.025 39.3732 132.993 39.9235C132.898 41.5248 131.68 43.1937 129.394 44.5108L50.7224 89.7704C46.3633 92.2783 39.7726 92.5489 35.9975 90.3793L2.54603 71.1325C0.753507 70.0996 -0.0839105 68.7058 0.00662112 67.2534C0.029254 66.8519 0.137892 66.3603 0.305375 65.9498C0.798773 64.7545 1.88968 63.7982 3.60073 62.8104L82.2727 17.5508Z",
    fill: "url(#paint19_linear_2164_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2727 17.4153C86.6318 14.9074 93.2225 14.6368 96.9977 16.8064L130.454 36.0532C131.54 36.6802 132.26 37.3027 132.649 38.1236C132.907 38.6604 133.025 39.2873 132.993 39.8602C132.898 41.466 131.68 43.1349 129.394 44.452L50.7225 89.7116C46.3634 92.2195 39.7727 92.4901 35.9975 90.3205L2.54606 71.0692C0.749011 70.0362 -0.0838797 68.6334 0.00665195 67.1765C0.0338114 66.757 0.142449 66.2924 0.323513 65.8729C0.825963 64.6912 1.9214 63.6447 3.60528 62.6749L82.2727 17.4153Z",
    fill: "url(#paint20_linear_2164_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0038 90.2574L2.54784 71.0106C-1.22733 68.841 -0.752037 65.0476 3.60706 62.5397L82.2745 17.2801C86.6336 14.7722 93.2243 14.5015 96.9995 16.6711L130.455 35.918C134.231 38.0876 133.755 41.881 129.396 44.3889L50.7242 89.6485C46.3697 92.1564 39.7744 92.427 36.0038 90.2574Z",
    fill: "url(#paint21_linear_2164_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0044 90.2936L2.54847 71.0467C0.864577 70.077 0.0226329 68.7824 0 67.4247C0 67.3029 0.00452658 64.6913 0.0135797 64.5695C0.153904 62.9953 1.36703 63.8613 3.60316 62.5758L82.2751 17.3162C86.6342 14.8083 93.2249 14.5377 97.0001 16.7073L130.456 35.9541C132.14 36.9239 132.977 35.2189 133.005 36.5766C133.005 36.6938 133.005 39.8107 132.991 39.9325C132.855 41.5067 131.642 43.1395 129.397 44.4296L50.7249 89.6891C46.3703 92.1925 39.7751 92.4677 36.0044 90.2936Z",
    fill: "url(#paint22_linear_2164_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2713 17.181C86.6304 14.673 93.2211 14.4024 96.9963 16.572L130.452 35.8188C132.1 36.7661 132.829 35.1783 132.974 36.4954C132.992 36.6533 133.001 39.6664 132.983 39.8243C132.802 41.385 131.625 43.0088 129.398 44.2898L50.721 89.5494C46.3619 92.0573 39.7712 92.3279 35.9961 90.1583L2.54463 70.9115C0.86527 69.9462 0.0414324 68.6562 0.000693217 67.3075C-0.00383336 67.1541 0.014273 64.6237 0.0414324 64.4703C0.290394 62.9367 1.40393 63.708 3.60385 62.4405L82.2713 17.181Z",
    fill: "url(#paint23_linear_2164_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.272 17.0455C86.6311 14.5376 93.2218 14.2669 96.997 16.4365L130.453 35.6833C132.064 36.608 132.734 35.1421 132.947 36.4186C132.979 36.6125 133.006 39.5219 132.979 39.7249C132.766 41.272 131.612 42.8868 129.398 44.1588L50.7217 89.4139C46.3626 91.9218 39.7719 92.1924 35.9968 90.0228L2.54534 70.776C0.875032 69.8152 0.0602473 68.5342 0.00140174 67.19C-0.00765142 67.0051 0.0285612 64.5604 0.0693005 64.3709C0.381635 62.8779 1.44538 63.55 3.60003 62.3095L82.272 17.0455Z",
    fill: "url(#paint24_linear_2164_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2727 16.9102C86.6318 14.4023 93.2225 14.1317 96.9977 16.3013L130.454 35.5481C132.029 36.4547 132.667 35.1015 132.921 36.3374C132.97 36.572 133.007 39.3731 132.97 39.6167C132.735 41.1548 131.594 42.7516 129.394 44.019L50.7224 89.2786C46.3633 91.7865 39.7726 92.0572 35.9975 89.8876L2.54605 70.6407C0.880267 69.6845 0.0745358 68.408 0.00211053 67.0728C-0.0114692 66.8518 0.0428498 64.4973 0.0971687 64.2672C0.459295 62.8103 1.4823 63.3876 3.60074 62.1698L82.2727 16.9102Z",
    fill: "url(#paint25_linear_2164_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2724 16.7749C86.6315 14.267 93.2222 13.9964 96.9974 16.166L130.453 35.4128C131.988 36.2969 132.608 35.061 132.893 36.2563C132.961 36.5315 133.011 39.2288 132.966 39.513C132.717 41.0376 131.58 42.6253 129.394 43.8838L50.7222 89.1434C46.3631 91.6513 39.7724 91.9219 35.9972 89.7523L2.54578 70.5055C0.889053 69.5537 0.0833219 68.2817 0.00184341 66.9511C-0.0117363 66.6985 0.0516358 64.4297 0.128588 64.1635C0.5224 62.7427 1.5273 63.2298 3.605 62.0345L82.2724 16.7749Z",
    fill: "url(#paint26_linear_2164_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2764 16.6397C86.6355 14.1318 93.2262 13.8612 97.0014 16.0308L130.457 35.2776C131.956 36.1391 132.562 35.0205 132.87 36.1797C132.956 36.4955 133.019 39.0846 132.961 39.4093C132.698 40.9249 131.566 42.4991 129.398 43.7485L50.7262 89.0081C46.3671 91.516 39.7764 91.7867 36.0012 89.617L2.54977 70.3657C0.897564 69.4185 0.0963592 68.1555 0.0103542 66.8294C-0.00775216 66.5407 0.0737263 64.3621 0.164258 64.0599C0.580703 62.6706 1.57202 63.0675 3.60899 61.8948L82.2764 16.6397Z",
    fill: "url(#paint27_linear_2164_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2772 16.5042C86.6363 13.9963 93.227 13.7257 97.0022 15.8953L130.458 35.1421C131.92 35.9856 132.522 34.9797 132.844 36.0983C132.948 36.4547 133.025 38.9355 132.957 39.3054C132.681 40.8074 131.554 42.3726 129.399 43.613L50.727 88.8726C46.3679 91.3805 39.7772 91.6512 36.002 89.4815L2.55059 70.2302C0.907439 69.283 0.106234 68.029 0.0111759 66.7119C-0.011457 66.3917 0.0836012 64.2942 0.192239 63.9559C0.631317 62.5982 1.60906 62.9095 3.60981 61.7593L82.2772 16.5042Z",
    fill: "url(#paint28_linear_2164_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2781 16.3645C86.6372 13.8566 93.2279 13.586 97.0031 15.7556L130.459 35.0024C131.885 35.8234 132.482 34.9303 132.822 36.0173C132.944 36.4143 133.035 38.7914 132.958 39.1973C132.673 40.6903 131.545 42.242 129.404 43.4734L50.7278 88.733C46.3687 91.2409 39.778 91.5115 36.0029 89.3419L2.55142 70.0951C0.917329 69.1524 0.111597 67.9074 0.0120125 66.5948C-0.015147 66.2385 0.093491 64.2313 0.220235 63.8569C0.67742 62.5308 1.65063 62.7518 3.60612 61.6241L82.2781 16.3645Z",
    fill: "url(#paint29_linear_2164_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2713 16.229C86.6304 13.7211 93.2211 13.4505 96.9962 15.6201L130.452 34.8669C131.842 35.6653 132.439 34.885 132.788 35.936C132.933 36.3735 133.032 38.6423 132.942 39.0889C132.648 40.5729 131.52 42.111 129.397 43.3334L50.721 88.5975C46.3619 91.1054 39.7712 91.376 35.996 89.2064L2.5446 69.9596C0.915034 69.0214 0.113829 67.781 0.00519099 66.4774C-0.0264951 66.0895 0.091196 64.1679 0.240573 63.7575C0.711338 62.4629 1.68003 62.5937 3.5993 61.4931L82.2713 16.229Z",
    fill: "url(#paint30_linear_2164_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2754 16.0938C86.6345 13.5859 93.2252 13.3153 97.0004 15.4849L130.452 34.7317C131.801 35.5075 132.403 34.8399 132.76 35.8593C132.928 36.3375 133.036 38.4981 132.937 38.9897C132.638 40.4602 131.507 41.9893 129.397 43.2026L50.7251 88.4622C46.3661 90.9701 39.7753 91.2408 36.0002 89.0711L2.54875 69.8243C0.928232 68.8906 0.1225 67.6547 0.0138622 66.3602C-0.0223504 65.9407 0.10892 64.1003 0.276404 63.6538C0.756221 62.3863 1.72944 62.4359 3.60344 61.3534L82.2754 16.0938Z",
    fill: "url(#paint31_linear_2164_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2764 15.9585C86.6355 13.4506 93.2262 13.18 97.0014 15.3496L130.457 34.5964C131.77 35.3542 132.372 34.7949 132.739 35.7782C132.929 36.2924 133.047 38.3538 132.938 38.8815C132.63 40.343 131.498 41.8585 129.403 43.0629L50.7262 88.327C46.3671 90.8349 39.7764 91.1055 36.0012 88.9359L2.54976 69.6891C0.933775 68.7599 0.128044 67.533 0.0148793 66.2384C-0.0258599 65.7829 0.114464 64.0327 0.309107 63.5501C0.802504 62.3097 1.77119 62.2736 3.60898 61.2181L82.2764 15.9585Z",
    fill: "url(#paint32_linear_2164_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2775 15.8233C86.6366 13.3154 93.2273 13.0447 97.0024 15.2144L130.458 34.4612C131.735 35.1964 132.341 34.7499 132.713 35.7016C132.93 36.2564 133.057 38.2095 132.93 38.7824C132.613 40.2348 131.481 41.7368 129.399 42.9321L50.7272 88.1917C46.3681 90.6996 39.7774 90.9702 36.0022 88.8006L2.5508 69.5538C0.943868 68.6291 0.13361 67.4068 0.0159192 66.1212C-0.0293466 65.6341 0.120031 63.9652 0.337306 63.4509C0.839757 62.2376 1.81297 62.1158 3.6055 61.0829L82.2775 15.8233Z",
    fill: "url(#paint33_linear_2164_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.274 15.6878C86.6331 13.1799 93.2238 12.9092 96.999 15.0789L130.455 34.3257C131.695 35.0384 132.306 34.7001 132.682 35.6202C132.926 36.2111 133.058 38.0605 132.922 38.6739C132.601 40.1173 131.464 41.6058 129.4 42.7921L50.7237 88.0562C46.3646 90.5641 39.7739 90.8348 35.9988 88.6651L2.54733 69.4138C0.949448 68.4936 0.13919 67.2803 0.0169721 65.9993C-0.0328203 65.476 0.12561 63.8973 0.365519 63.3425C0.877022 62.1562 1.85024 61.9532 3.60655 60.9429L82.274 15.6878Z",
    fill: "url(#paint34_linear_2164_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2751 15.5481C86.6342 13.0402 93.2249 12.7696 97 14.9392L130.456 34.186C131.66 34.8762 132.276 34.6506 132.656 35.5392C132.927 36.1662 133.063 37.9163 132.914 38.5704C132.588 40.0047 131.443 41.4797 129.397 42.657L50.7248 87.9166C46.3657 90.4245 39.775 90.6951 35.9998 88.5255L2.54839 69.2787C0.955038 68.363 0.14478 67.1542 0.0180353 65.8822C-0.0362837 65.3274 0.1312 63.8298 0.393742 63.2435C0.914298 62.0842 1.88751 61.7955 3.60761 60.8077L82.2751 15.5481Z",
    fill: "url(#paint35_linear_2164_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2763 15.4126C86.6354 12.9047 93.2261 12.6341 97.0013 14.8037L130.457 34.0505C131.625 34.7226 132.245 34.6008 132.63 35.4578C132.929 36.1209 133.074 37.7673 132.911 38.4619C132.576 39.8873 131.43 41.3487 129.398 42.517L50.7261 87.7811C46.367 90.289 39.7763 90.5596 36.0011 88.39L2.54967 69.1432C0.965364 68.232 0.150579 67.0322 0.0193084 65.7647C-0.0395372 65.1738 0.132473 63.762 0.422174 63.144C0.951784 62.0119 1.92953 61.6375 3.60436 60.6767L82.2763 15.4126Z",
    fill: "url(#paint36_linear_2164_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2788 15.2774C86.6379 12.7695 93.2286 12.4988 97.0038 14.6685L130.46 33.9153C131.587 34.5648 132.216 34.5513 132.61 35.3812C132.94 36.0804 133.09 37.6275 132.913 38.3628C132.574 39.7791 131.424 41.227 129.405 42.3862L50.7285 87.6458C46.3694 90.1537 39.7787 90.4243 36.0036 88.2547L2.55213 69.0079C0.972356 68.1013 0.157571 66.906 0.0217737 65.6475C-0.046125 65.025 0.139465 63.6944 0.451799 63.0449C0.990462 61.9353 1.9682 61.4842 3.60683 60.5415L82.2788 15.2774Z",
    fill: "url(#paint37_linear_2164_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2756 15.1421C86.6347 12.6342 93.2254 12.3636 97.0006 14.5332L130.457 33.78C131.547 34.407 132.181 34.5017 132.579 35.3001C132.942 36.0353 133.091 37.4787 132.901 38.2546C132.557 39.6619 131.403 41.0917 129.402 42.2465L50.7253 87.5106C46.3662 90.0185 39.7755 90.2891 36.0004 88.1195L2.54893 68.8727C0.978204 67.9705 0.158892 66.7842 0.0230951 65.5258C-0.0493302 64.8717 0.140786 63.6178 0.484806 62.9367C1.03252 61.8541 2.01479 61.3174 3.60815 60.3972L82.2756 15.1421Z",
    fill: "url(#paint38_linear_2164_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2772 15.0069C86.6363 12.499 93.227 12.2283 97.0022 14.3979L130.458 33.6448C131.513 34.2492 132.151 34.4522 132.554 35.2235C132.952 35.9903 133.102 37.339 132.898 38.1554C132.545 39.5537 131.391 40.97 129.403 42.1157L50.7269 87.3753C46.3678 89.8832 39.7771 90.1538 36.002 87.9842L2.55053 68.7374C0.988856 67.8398 0.165018 66.658 0.024694 65.4086C-0.0522579 64.7184 0.137858 63.5502 0.513565 62.8375C1.06581 61.7775 2.0526 61.1596 3.60975 60.2665L82.2772 15.0069Z",
    fill: "url(#paint39_linear_2164_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2722 14.8714C86.6313 12.3635 93.222 12.0928 96.9972 14.2624L130.453 33.5093C131.472 34.0957 132.114 34.3979 132.522 35.1421C132.956 35.9405 133.106 37.1945 132.884 38.047C132.526 39.4362 131.368 40.839 129.394 41.9757L50.722 87.2398C46.3629 89.7477 39.7722 90.0183 35.997 87.8487L2.54557 68.5974C0.988431 67.6998 0.164593 66.527 0.0197423 65.2866C-0.0662627 64.5649 0.132907 63.4733 0.535773 62.7336C1.09707 61.6962 2.08839 61.0015 3.60027 60.1265L82.2722 14.8714Z",
    fill: "url(#paint40_linear_2164_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2739 14.7317C86.633 12.2238 93.2237 11.9532 96.9989 14.1228L130.455 33.3696C131.437 33.9335 132.084 34.3439 132.496 35.0611C132.967 35.8866 133.116 37.0458 132.881 37.9434C132.519 39.3236 131.356 40.7129 129.396 41.8406L50.7237 87.1047C46.3646 89.6126 39.7739 89.8832 35.9987 87.7136L2.54726 68.4623C0.999172 67.5692 0.170807 66.4054 0.0214303 65.1695C-0.0691014 64.4117 0.130068 63.4013 0.56462 62.63C1.13497 61.6151 2.12629 60.8393 3.60196 59.9913L82.2739 14.7317Z",
    fill: "url(#paint41_linear_2164_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2789 14.5962C86.638 12.0883 93.2287 11.8177 97.0039 13.9873L130.46 33.2341C131.401 33.7754 132.058 34.2896 132.474 34.9797C132.986 35.8368 133.131 36.9013 132.882 37.835C132.51 39.2062 131.347 40.5819 129.405 41.7006L50.7287 86.9647C46.3696 89.4726 39.7789 89.7432 36.0037 87.5736L2.55227 68.3268C1.0087 67.4382 0.180339 66.2789 0.0309616 65.0521C-0.0640966 64.2627 0.135073 63.329 0.601311 62.5306C1.18071 61.5383 2.17203 60.6813 3.60696 59.8558L82.2789 14.5962Z",
    fill: "url(#paint42_linear_2164_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0038 87.4383L2.54784 68.1915C-1.22733 66.0219 -0.752037 62.2285 3.60706 59.7206L82.2745 14.461C86.6336 11.9531 93.2243 11.6824 96.9995 13.852L130.455 33.0989C134.231 35.2685 133.755 39.0619 129.396 41.5698L50.7242 86.8294C46.3697 89.3373 39.7744 89.6079 36.0038 87.4383Z",
    fill: "#CBA6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0038 87.4383L2.54784 68.1915C-1.22733 66.0219 -0.752037 62.2285 3.60706 59.7206L82.2745 14.461C86.6336 11.9531 93.2243 11.6824 96.9995 13.852L130.455 33.0989C134.231 35.2685 133.755 39.0619 129.396 41.5698L50.7242 86.8294C46.3697 89.3373 39.7744 89.6079 36.0038 87.4383Z",
    fill: "#CBA6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.63681 59.725L82.2816 14.4744C86.6271 11.9755 93.2043 11.7004 96.9704 13.87L130.413 33.1078C134.179 35.2729 133.704 39.0573 129.358 41.5562L50.7133 86.8067C46.3677 89.3056 39.7906 89.5808 36.0245 87.4157L2.58212 68.1734C-1.184 66.0083 -0.713233 62.2239 3.63681 59.725Z",
    fill: "#CCA7E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.66504 59.7251L82.2917 14.488C86.6282 11.9937 93.1872 11.723 96.9443 13.8836L130.373 33.1169C134.13 35.2775 133.659 39.0529 129.323 41.5472L50.6962 86.7843C46.3598 89.2786 39.8007 89.5493 36.0437 87.3887L2.61487 68.1554C-1.14219 65.9948 -0.671426 62.2194 3.66504 59.7251Z",
    fill: "#CCA8E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.68619 59.7297L82.2948 14.5062C86.6222 12.0163 93.1631 11.7457 96.9111 13.9017L130.331 33.126C134.079 35.2821 133.608 39.0485 129.281 41.5338L50.6721 86.7618C46.3447 89.2517 39.8038 89.5223 36.0558 87.3662L2.63603 68.1375C-1.10746 65.9814 -0.636691 62.2195 3.68619 59.7297Z",
    fill: "#CDA9E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.72005 59.7297L82.3015 14.5197C86.6153 12.0389 93.1472 11.7682 96.8816 13.9153L130.288 33.1351C134.027 35.2866 133.556 39.0395 129.242 41.5248L50.6562 86.7348C46.3423 89.2156 39.8105 89.4863 36.076 87.3392L2.66988 68.1194C-1.06455 65.9724 -0.598308 62.215 3.72005 59.7297Z",
    fill: "#CDAAE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.75012 59.7341L82.3135 14.5332C86.6182 12.0569 93.132 11.7862 96.8574 13.9333L130.25 33.144C133.98 35.2911 133.509 39.0349 129.204 41.5112L50.6455 86.7122C46.3407 89.1885 39.827 89.4591 36.1016 87.3121L2.70448 68.1013C-1.02542 65.9588 -0.554661 62.2105 3.75012 59.7341Z",
    fill: "#CEABE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.77206 59.7386L82.3173 14.5512C86.613 12.0794 93.1087 11.8133 96.8295 13.9513L130.209 33.1575C133.929 35.2956 133.463 39.0349 129.167 41.5067L50.6222 86.6896C46.3264 89.1614 39.8308 89.4275 36.1099 87.2895L2.73094 68.0833C-0.989907 65.9452 -0.523669 62.2059 3.77206 59.7386Z",
    fill: "#CEACE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.80028 59.7385L82.3274 14.5646C86.6096 12.1018 93.0916 11.8312 96.8034 13.9647L130.169 33.1619C133.881 35.2955 133.414 39.0258 129.128 41.4886L50.6051 86.6669C46.323 89.1297 39.8409 89.4004 36.1291 87.2669L2.7637 68.0651C-0.9481 65.9316 -0.481862 62.2058 3.80028 59.7385Z",
    fill: "#CFADE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.83262 59.7431L82.3326 14.5783C86.6057 12.12 93.0696 11.8538 96.7724 13.9829L130.129 33.171C133.831 35.3001 133.365 39.0213 129.092 41.4796L50.5877 86.6445C46.3146 89.1027 39.8506 89.3689 36.1479 87.2399L2.79603 68.0517C-0.906714 65.9227 -0.440476 62.2014 3.83262 59.7431Z",
    fill: "#CFAEE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.86237 59.7477L82.3442 14.5964C86.6083 12.1426 93.0541 11.8765 96.7478 14.001L130.091 33.1847C133.784 35.3092 133.318 39.0169 129.059 41.4707L50.5767 86.622C46.3126 89.0758 39.8668 89.3419 36.1731 87.2174L2.83031 68.0337C-0.863383 65.9092 -0.401672 62.197 3.86237 59.7477Z",
    fill: "#D0AFE6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.89133 59.7477L82.3551 14.6099C86.6055 12.1652 93.0423 11.8991 96.7225 14.0145L130.052 33.1892C133.736 35.3092 133.275 39.0079 129.02 41.4572L50.5604 86.595C46.3099 89.0397 39.8731 89.3058 36.193 87.1904L2.85927 68.0157C-0.820836 65.8957 -0.359125 62.197 3.89133 59.7477Z",
    fill: "#D1B0E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.91664 59.7522L82.3578 14.6234C86.5992 12.1832 93.0179 11.9171 96.6889 14.0325L130.005 33.2027C133.68 35.3182 133.218 39.0079 128.977 41.4481L50.5359 86.5724C46.2945 89.0126 39.8758 89.2787 36.2047 87.1633L2.88911 67.9931C-0.786478 65.8821 -0.329294 62.1925 3.91664 59.7522Z",
    fill: "#D1B1E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.94561 59.752L82.3641 14.6368C86.5965 12.2011 92.997 11.9394 96.659 14.0459L129.966 33.207C133.632 35.3135 133.17 38.9987 128.938 41.4344L50.5196 86.5496C46.2872 88.9854 39.8867 89.247 36.2247 87.1405L2.91807 67.9794C-0.743932 65.8684 -0.286747 62.1878 3.94561 59.752Z",
    fill: "#D2B2E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.97567 59.7567L82.376 14.6505C86.5948 12.2238 92.9818 11.9576 96.6393 14.0596L129.932 33.2117C133.59 35.3136 133.128 38.9898 128.909 41.4165L50.5089 86.5227C46.2901 88.9494 39.9031 89.2156 36.2457 87.1136L2.95267 67.9615C-0.704811 65.8596 -0.2431 62.1834 3.97567 59.7567Z",
    fill: "#D2B3E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.99761 59.7612L82.3799 14.6685C86.5896 12.2463 92.9585 11.9847 96.6069 14.0821L129.886 33.2297C133.535 35.3271 133.078 38.9898 128.863 41.412L50.4856 86.5046C46.2759 88.9268 39.907 89.1885 36.2586 87.091L2.97913 67.9434C-0.669292 65.846 -0.212108 62.1834 3.99761 59.7612Z",
    fill: "#D3B4E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.02994 59.7611L82.3896 14.682C86.5903 12.2643 92.941 12.0027 96.5804 14.0956L129.846 33.2342C133.486 35.3271 133.028 38.9807 128.828 41.3984L50.4681 86.4775C46.2675 88.8952 39.9167 89.1569 36.2773 87.0639L3.01146 67.9254C-0.627907 65.8324 -0.170722 62.1788 4.02994 59.7611Z",
    fill: "#D3B5E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.05817 59.7657L82.3952 14.6955C86.5868 12.2869 92.924 12.0252 96.5498 14.1091L129.807 33.2432C133.437 35.3316 132.98 38.9762 128.788 41.3849L50.4511 86.455C46.2595 88.8637 39.9223 89.1253 36.2965 87.0414L3.04422 67.9073C-0.586101 65.8189 -0.128916 62.1743 4.05817 59.7657Z",
    fill: "#D4B6E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.08866 59.7656L82.4076 14.709C86.5856 12.3049 92.9092 12.0432 96.526 14.1271L129.769 33.2522C133.39 35.3361 132.933 38.9717 128.755 41.3758L50.4363 86.4324C46.2583 88.8366 39.9347 89.0982 36.3179 87.0143L3.07471 67.8892C-0.542028 65.8098 -0.0893704 62.1698 4.08866 59.7656Z",
    fill: "#D5B7E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.121 59.7702L82.4173 14.7226C86.5863 12.323 92.8918 12.0659 96.4995 14.1408L129.729 33.2568C133.337 35.3317 132.884 38.9627 128.72 41.3579L50.4234 86.4054C46.2544 88.8051 39.9489 89.0622 36.3412 86.9873L3.10704 67.8713C-0.500643 65.7964 -0.0479848 62.1699 4.121 59.7702Z",
    fill: "#D5B8E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.14293 59.7748L82.4211 14.7407C86.581 12.3501 92.8684 12.0885 96.4716 14.1588L129.688 33.2703C133.286 35.3407 132.838 38.9582 128.678 41.3534L50.4001 86.3874C46.2401 88.7781 39.9527 89.0397 36.3496 86.9693L3.13351 67.8533C-0.465124 65.7829 -0.0169927 62.1654 4.14293 59.7748Z",
    fill: "#D6B9E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.173 59.7746L82.4285 14.7541C86.5749 12.3679 92.8487 12.1108 96.4428 14.1767L129.645 33.2792C133.235 35.3451 132.787 38.9536 128.64 41.3397L50.3849 86.3602C46.2385 88.7463 39.9647 89.0034 36.3706 86.9376L3.1681 67.8396C-0.426004 65.7692 0.0266543 62.1607 4.173 59.7746Z",
    fill: "#D6BAE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.20123 59.7793L82.4341 14.7678C86.5714 12.3862 92.8272 12.1291 96.4122 14.1904L129.606 33.2884C133.186 35.3498 132.738 38.9492 128.601 41.3309L50.3678 86.3424C46.2305 88.724 39.9748 88.9811 36.3897 86.9197L3.20085 67.8217C-0.384197 65.7604 0.0684606 62.1564 4.20123 59.7793Z",
    fill: "#D7BBE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.23509 59.7791L82.4499 14.7811C86.5781 12.4085 92.8203 12.1514 96.3917 14.2038L129.572 33.2927C133.143 35.3496 132.695 38.94 128.571 41.3126L50.3564 86.3106C46.2282 88.6832 39.986 88.9403 36.4146 86.8879L3.23471 67.799C-0.341287 65.7466 0.106844 62.1562 4.23509 59.7791Z",
    fill: "#D7BCE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.2555 59.7837L82.4477 14.7992C86.5623 12.4312 92.7909 12.1741 96.3533 14.2264L129.52 33.3063C133.082 35.3587 132.638 38.9401 128.519 41.3082L50.3316 86.2926C46.2169 88.6607 39.9883 88.9178 36.4259 86.8655L3.25965 67.7855C-0.307293 65.7332 0.140839 62.1517 4.2555 59.7837Z",
    fill: "#D8BDE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.28599 59.7883L82.46 14.8129C86.5657 12.4493 92.7761 12.1967 96.3295 14.24L129.482 33.3154C133.036 35.3587 132.592 38.9357 128.486 41.2947L50.3123 86.2701C46.2067 88.6337 39.9962 88.8863 36.4428 86.843L3.29014 67.7676C-0.263221 65.7197 0.180384 62.1473 4.28599 59.7883Z",
    fill: "#D8BEEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.31833 59.7882L82.4697 14.8263C86.5663 12.4717 92.7587 12.2146 96.303 14.2534L129.447 33.3198C132.991 35.3586 132.547 38.922 128.455 41.2811L50.2993 86.243C46.2028 88.5975 40.0104 88.8546 36.4661 86.8158L3.32248 67.7494C-0.221835 65.7106 0.221769 62.1472 4.31833 59.7882Z",
    fill: "#D9BFEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.34655 59.7926L82.4799 14.8398C86.5628 12.4897 92.7416 12.2326 96.2814 14.2714L129.411 33.3333C132.947 35.3676 132.503 38.922 128.42 41.272L50.2868 86.2204C46.2038 88.5704 40.0251 88.8275 36.4853 86.7887L3.35523 67.7313C-0.180029 65.697 0.263576 62.1427 4.34655 59.7926Z",
    fill: "#DAC0EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.36849 59.7927L82.4792 14.8534C86.5531 12.5079 92.7138 12.2553 96.2445 14.2851L129.361 33.3379C132.887 35.3677 132.448 38.913 128.374 41.2586L50.2635 86.1979C46.1896 88.5434 40.0289 88.796 36.4982 86.7662L3.3817 67.7134C-0.14451 65.6836 0.294568 62.1382 4.36849 59.7927Z",
    fill: "#DAC1EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.40266 59.7973L82.4952 14.8715C86.5601 12.535 92.7072 12.2779 96.2243 14.3031L129.327 33.347C132.844 35.3722 132.405 38.9086 128.34 41.2451L50.2479 86.1709C46.183 88.5074 40.0359 88.7645 36.5188 86.7392L3.41587 67.6954C-0.105811 65.6701 0.337794 62.1338 4.40266 59.7973Z",
    fill: "#DBC2EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.43089 59.8018L82.5008 14.8851C86.5521 12.5531 92.6856 12.3005 96.1937 14.3212L129.288 33.3606C132.796 35.3813 132.357 38.9086 128.305 41.2406L50.2308 86.1529C46.1795 88.4849 40.046 88.7375 36.5379 86.7167L3.44862 67.6774C-0.0640043 65.6611 0.379601 62.1338 4.43089 59.8018Z",
    fill: "#DBC2EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.46138 59.8018L82.5087 14.8986C86.5509 12.5711 92.6663 12.3185 96.1654 14.3347L129.246 33.3651C132.745 35.3768 132.306 38.8951 128.263 41.2226L50.2161 86.1258C46.1738 88.4533 40.0584 88.7059 36.5594 86.6896L3.47911 67.6593C-0.0199325 65.6476 0.419146 62.1293 4.46138 59.8018Z",
    fill: "#DCC3EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.4818 59.8062L82.511 14.9165C86.5442 12.5981 92.6415 12.3455 96.1315 14.3527L129.198 33.3785C132.688 35.3857 132.254 38.895 128.22 41.2134L50.1957 86.1032C46.1626 88.4216 40.0652 88.6742 36.5753 86.667L3.50406 67.6412C0.0140617 65.634 0.45314 62.1247 4.4818 59.8062Z",
    fill: "#DCC4EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.51565 59.8107L82.5222 14.93C86.5418 12.6161 92.6256 12.3635 96.1065 14.3707L129.16 33.3875C132.641 35.3902 132.206 38.8904 128.182 41.2044L50.1753 86.0851C46.1557 88.399 40.0719 88.6516 36.591 86.6444L3.53791 67.6231C0.0569718 65.6204 0.491523 62.1201 4.51565 59.8107Z",
    fill: "#DDC5EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.54388 59.8108L82.5323 14.9436C86.5429 12.6342 92.6085 12.3861 96.0849 14.3843L129.129 33.3921C132.601 35.3903 132.166 38.8815 128.156 41.1864L50.1673 86.0536C46.1567 88.363 40.0911 88.6111 36.6147 86.6129L3.57067 67.6051C0.0987782 65.6114 0.53333 62.1202 4.54388 59.8108Z",
    fill: "#DEC6EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.57211 59.8153L82.5379 14.9617C86.5394 12.6613 92.5869 12.4087 96.0543 14.4024L129.085 33.4056C132.548 35.3993 132.113 38.8815 128.116 41.1819L50.1502 86.0356C46.1488 88.336 40.1012 88.5886 36.6339 86.5949L3.60342 67.5916C0.140585 65.5979 0.575137 62.1157 4.57211 59.8153Z",
    fill: "#DEC7ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.59999 59.8153L82.5477 14.9707C86.5356 12.6748 92.5741 12.4267 96.0279 14.4159L129.045 33.4101C132.499 35.3993 132.069 38.8679 128.076 41.1638L50.1283 86.0084C46.1404 88.3043 40.102 88.5524 36.6482 86.5632L3.6313 67.5735C0.172997 65.5843 0.607548 62.1112 4.59999 59.8153Z",
    fill: "#DFC8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.62822 59.8199L82.5533 14.9888C86.5322 12.6974 92.5525 12.4493 95.9973 14.434L129.001 33.4237C132.445 35.4084 132.015 38.868 128.036 41.1594L50.1113 85.9905C46.1324 88.2819 40.1121 88.53 36.6674 86.5453L3.66406 67.5556C0.214803 65.5709 0.649355 62.1113 4.62822 59.8199Z",
    fill: "#DFC9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.65871 59.8244L82.5657 15.0024C86.5355 12.72 92.5377 12.4719 95.9734 14.4475L128.963 33.4282C132.399 35.4039 131.969 38.859 127.999 41.1414L50.092 85.9635C46.1222 88.2458 40.1199 88.4939 36.6843 86.5183L3.69455 67.5376C0.258875 65.5574 0.6889 62.1068 4.65871 59.8244Z",
    fill: "#E0CAED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.68694 59.8244L82.5713 15.0158C86.5275 12.738 92.5162 12.4899 95.9428 14.4655L128.923 33.4372C132.35 35.4084 131.92 38.8545 127.964 41.1323L50.0795 85.9408C46.1233 88.2187 40.1346 88.4668 36.708 86.4911L3.7273 67.5195C0.300681 65.5483 0.730707 62.1022 4.68694 59.8244Z",
    fill: "#E0CBEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.71927 59.8288L82.581 15.0338C86.5282 12.7649 92.4987 12.5169 95.9208 14.4835L128.888 33.4507C132.305 35.4173 131.88 38.8544 127.928 41.1232L50.0666 85.9182C46.1194 88.1871 40.1488 88.4352 36.7267 86.4685L3.75964 67.5013C0.342067 65.5347 0.772092 62.0976 4.71927 59.8288Z",
    fill: "#E1CCEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.74121 59.8289L82.5848 15.0429C86.5229 12.7786 92.4754 12.5305 95.8884 14.4926L128.842 33.4507C132.25 35.4129 131.825 38.8409 127.887 41.1053L50.0432 85.8912C46.1051 88.1556 40.1527 88.4036 36.7396 86.4415L3.7861 67.4834C0.377586 65.5213 0.803084 62.0977 4.74121 59.8289Z",
    fill: "#E1CDEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.76944 59.8333L82.5904 15.0609C86.515 12.8011 92.4584 12.5575 95.8578 14.5151L128.798 33.4687C132.197 35.4263 131.772 38.8409 127.847 41.1007L50.0262 85.8732C46.1016 88.133 40.1582 88.3765 36.7588 86.4189L3.81885 67.4653C0.419392 65.5077 0.844891 62.0931 4.76944 59.8333Z",
    fill: "#E2CEEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.80177 59.8379L82.6046 15.079C86.5201 12.8282 92.4454 12.5801 95.8358 14.5332L128.767 33.4778C132.157 35.4309 131.732 38.8364 127.816 41.0917L50.0133 85.8506C46.0978 88.1014 40.1725 88.3495 36.7821 86.3964L3.85119 67.4518C0.460778 65.4987 0.886277 62.0887 4.80177 59.8379Z",
    fill: "#E3CFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.82555 59.8378L82.6058 15.0879C86.5122 12.8416 92.4194 12.5981 95.8008 14.5422L128.718 33.4777C132.099 35.4218 131.674 38.8228 127.772 41.0691L49.9918 85.819C46.0853 88.0653 40.1781 88.3089 36.7968 86.3648L3.87949 67.4292C0.493611 65.4851 0.919109 62.0841 4.82555 59.8378Z",
    fill: "#E3D0EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.85452 59.8424L82.6167 15.1061C86.5095 12.8643 92.4031 12.6207 95.7754 14.5603L128.679 33.4914C132.051 35.4309 131.63 38.8229 127.733 41.0647L49.971 85.801C46.0781 88.0428 40.1845 88.2864 36.8122 86.3468L3.90846 67.4112C0.536158 65.4717 0.961656 62.0842 4.85452 59.8424Z",
    fill: "#E4D1EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.88837 59.8424L82.6279 15.1196C86.5117 12.8869 92.3872 12.6433 95.7504 14.5783L128.641 33.5004C132.004 35.4355 131.583 38.8184 127.699 41.0512L49.9595 85.774C46.0757 88.0068 40.2002 88.2503 36.837 86.3153L3.94232 67.3932C0.579068 65.4582 1.00004 62.0797 4.88837 59.8424Z",
    fill: "#E4D2F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.9166 59.8469L82.638 15.1331C86.5127 12.9049 92.3701 12.6613 95.7289 14.5918L128.61 33.5094C131.964 35.4399 131.543 38.8094 127.668 41.0376L49.947 85.7514C46.0723 87.9797 40.2149 88.2232 36.8562 86.2927L3.97507 67.3796C0.620875 65.4491 1.04185 62.0751 4.9166 59.8469Z",
    fill: "#E5D3F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.94483 59.8514L82.6436 15.1511C86.5093 12.9274 92.3531 12.6883 95.6982 14.6098L128.566 33.5184C131.911 35.4444 131.49 38.8048 127.629 41.0286L49.93 85.7288C46.0643 87.9526 40.2205 88.1916 36.8753 86.2701L4.00782 67.3616C0.662681 65.4355 1.08365 62.0706 4.94483 59.8514Z",
    fill: "#E5D4F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.96677 59.8514L82.6429 15.1602C86.495 12.9454 92.3253 12.7019 95.6613 14.6234L128.515 33.5229C131.851 35.4444 131.435 38.7958 127.583 41.0105L49.9067 85.7018C46.0545 87.9165 40.2243 88.1601 36.8882 86.2385L4.03429 67.3435C0.6982 65.422 1.11464 62.0706 4.96677 59.8514Z",
    fill: "#E6D5F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.9991 59.8559L82.6571 15.1782C86.5002 12.968 92.3123 12.7289 95.6393 14.6414L128.48 33.5364C131.807 35.4489 131.39 38.7958 127.547 41.006L49.8892 85.6837C46.0461 87.8939 40.234 88.133 36.907 86.2205L4.06662 67.3255C0.739585 65.4085 1.15603 62.0661 4.9991 59.8559Z",
    fill: "#E7D6F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.03069 59.8605L82.6661 15.1963C86.5001 12.9906 92.2941 12.7515 95.6121 14.6595L128.439 33.5455C131.757 35.4535 131.34 38.7914 127.511 40.9925L49.8755 85.6567C46.0415 87.8624 40.2475 88.1015 36.9295 86.1935L4.10274 67.3075C0.78023 65.3995 1.19668 62.0617 5.03069 59.8605Z",
    fill: "#E7D7F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.05184 59.8604L82.6691 15.2052C86.4896 13.0085 92.27 12.7695 95.5789 14.673L128.397 33.5544C131.706 35.4579 131.289 38.7822 127.469 40.9834L49.8514 85.6386C46.031 87.8352 40.2505 88.0743 36.9416 86.1708L4.1239 67.2894C0.814965 65.3859 1.23141 62.0616 5.05184 59.8604Z",
    fill: "#E8D8F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.08418 59.865L82.6788 15.2233C86.4902 13.0312 92.2525 12.7921 95.557 14.6911L128.361 33.5635C131.661 35.4625 131.249 38.7778 127.438 40.97L49.8385 85.6116C46.0271 87.8038 40.2648 88.0428 36.9604 86.1439L4.15623 67.2714C0.856351 65.3724 1.2728 62.0571 5.08418 59.865Z",
    fill: "#E8D9F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.11393 59.8648L82.6905 15.2367C86.4928 13.0491 92.2416 12.8145 95.5324 14.7045L128.323 33.5679C131.614 35.4623 131.202 38.7686 127.4 40.9563L49.823 85.5844C46.0206 87.772 40.2719 88.0066 36.9811 86.1166L4.19051 67.2532C0.899682 65.3587 1.3116 62.0525 5.11393 59.8648Z",
    fill: "#E9DAF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.14216 59.8695L82.6961 15.2504C86.4848 13.0718 92.22 12.8327 95.5018 14.7226L128.279 33.5816C131.561 35.4715 131.149 38.7688 127.36 40.9474L49.8059 85.5665C46.0172 87.7451 40.282 87.9842 37.0002 86.0942L4.22326 67.2353C0.941489 65.3499 1.35341 62.0481 5.14216 59.8695Z",
    fill: "#E9DBF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.17191 59.8739L82.7077 15.2684C86.4874 13.0943 92.2045 12.8597 95.4772 14.7406L128.245 33.5905C131.518 35.4715 131.106 38.7642 127.326 40.9383L49.7904 85.5439C46.0107 87.718 40.2936 87.9526 37.0209 86.0716L4.25754 67.2172C0.98482 65.3363 1.39221 62.0481 5.17191 59.8739Z",
    fill: "#EADCF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.19643 59.874L82.7096 15.2775C86.4802 13.1079 92.1792 12.8733 95.4429 14.7497L128.197 33.5951C131.461 35.4715 131.053 38.7508 127.283 40.9204L49.7697 85.5169C45.999 87.6865 40.3001 87.9211 37.0364 86.0446L4.28206 67.1993C1.01839 65.3228 1.42578 62.0436 5.19643 59.874Z",
    fill: "#EADDF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.22465 59.8784L82.7152 15.2954C86.4723 13.1348 92.1576 12.9003 95.4122 14.7722L128.153 33.6086C131.408 35.4805 131 38.7507 127.243 40.9158L49.7526 85.4988C45.9956 87.6594 40.3102 87.8939 37.0556 86.022L4.31481 67.1811C1.0602 65.3092 1.46759 62.039 5.22465 59.8784Z",
    fill: "#EBDEF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.737 53.6402L117.716 51.3534C118.214 51.0692 118.616 50.3024 118.616 49.6393C118.616 48.9808 118.214 48.6741 117.716 48.9627L113.737 51.2496C113.239 51.5338 112.836 52.3006 112.836 52.9637C112.836 53.6222 113.239 53.9289 113.737 53.6402Z",
    fill: "url(#paint43_linear_2164_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.378 53.514C113.446 53.514 113.532 53.487 113.618 53.4374L117.597 51.1505C118.022 50.9069 118.38 50.2168 118.38 49.6394C118.38 49.3868 118.299 49.0891 118.072 49.0891C118.004 49.0891 117.918 49.1162 117.832 49.1658L113.853 51.4527C113.428 51.6962 113.07 52.3864 113.07 52.9637C113.07 53.2208 113.152 53.514 113.378 53.514Z",
    fill: "url(#paint44_linear_2164_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.627 57.7269L110.606 55.44C111.104 55.1559 111.507 54.3891 111.507 53.726C111.507 53.0674 111.104 52.7607 110.606 53.0494L106.627 55.3363C106.129 55.6205 105.727 56.3873 105.727 57.0503C105.731 57.7089 106.134 58.0156 106.627 57.7269Z",
    fill: "url(#paint45_linear_2164_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.277 57.6005C106.344 57.6005 106.43 57.5734 106.516 57.5238L110.495 55.2369C110.921 54.9933 111.278 54.3032 111.278 53.7258C111.278 53.4732 111.197 53.1755 110.971 53.1755C110.903 53.1755 110.817 53.2026 110.731 53.2522L106.752 55.5391C106.326 55.7827 105.969 56.4728 105.969 57.0502C105.969 57.3073 106.046 57.6005 106.277 57.6005Z",
    fill: "url(#paint46_linear_2164_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7196 86.1619C40.8908 86.1619 39.1707 85.7469 37.8671 84.9981L6.05426 66.694C4.7144 65.9227 3.97656 64.8853 3.97656 63.7757C3.97656 62.6705 4.70534 61.6466 6.0271 60.8843L85.2604 15.3C86.5414 14.5603 88.2479 14.1543 90.0585 14.1543C91.8873 14.1543 93.6074 14.5693 94.911 15.318L126.724 33.6221C128.064 34.3935 128.802 35.4309 128.802 36.545C128.802 37.6501 128.073 38.674 126.751 39.4363L47.5177 85.0162C46.2322 85.7514 44.5302 86.1619 42.7196 86.1619ZM90.0585 14.6054C88.3249 14.6054 86.7044 14.9888 85.4867 15.6879L6.25343 61.2768C5.07652 61.9534 4.42922 62.842 4.42922 63.7757C4.42922 64.7184 5.08557 65.616 6.28059 66.3061L38.0934 84.6102C39.3292 85.3184 40.9678 85.7108 42.7196 85.7108C44.4533 85.7108 46.0738 85.3274 47.2914 84.6283L126.525 39.0394C127.702 38.3628 128.349 37.4742 128.349 36.5405C128.349 35.5978 127.693 34.6957 126.498 34.0101L94.6847 15.706C93.449 14.9978 91.8058 14.6054 90.0585 14.6054Z",
    fill: "url(#paint47_linear_2164_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.335 28.5432L104.445 24.0011C104.133 23.8206 104.173 23.5094 104.531 23.3019C104.888 23.0944 105.432 23.0719 105.744 23.2523L113.634 27.7945C113.946 27.9749 113.905 28.2861 113.548 28.4936C113.186 28.7011 112.642 28.7237 112.335 28.5432Z",
    fill: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.1561 49.9417L64.032 46.9917L62.837 47.6819L67.961 50.6318L69.1561 49.9417ZM66.8249 51.782L60.714 48.2682L59.519 48.9584L65.6299 52.4721L66.8249 51.782ZM74.339 52.9277L70.1429 50.5145L68.9478 51.2047L73.144 53.6178L74.339 52.9277ZM76.9644 54.4343L75.3303 53.4915L74.1353 54.1817L75.7694 55.1244L76.9644 54.4343ZM52.9192 40.6047L49.1757 38.4531L47.9807 39.1432L51.7242 41.2948L52.9192 40.6047ZM52.1316 43.3291L46.4145 40.0409L45.2195 40.731L50.9366 44.0192L52.1316 43.3291ZM67.8117 52.3504L66.6166 53.0405L68.2236 53.9652L69.4186 53.275L67.8117 52.3504ZM60.5737 45.0071L53.906 41.173L52.711 41.8632L59.3786 45.6972L60.5737 45.0071ZM63.0406 46.4279L61.5605 45.5754L60.3654 46.2655L61.8456 47.118L63.0406 46.4279ZM59.7272 47.6954L56.5178 45.8505L55.3228 46.5407L58.5322 48.3855L59.7272 47.6954ZM53.1229 43.8974L51.9279 44.5876L54.336 45.9723L55.5311 45.2822L53.1229 43.8974ZM69.2104 54.529L73.5921 57.0504L74.7871 56.3603L70.4054 53.8389L69.2104 54.529ZM83.3514 58.1104L77.9512 55.0026L76.7562 55.6927L82.1564 58.8005L83.3514 58.1104ZM86.8414 60.1176L84.3427 58.6788L83.1477 59.3689L85.6464 60.8078L86.8414 60.1176ZM56.6129 55.6296L53.4896 53.8343L52.5978 54.3486L55.7212 56.1438L56.6129 55.6296ZM57.5952 54.8537L62.2259 57.524L63.1176 57.0098L58.4869 54.3395L57.5952 54.8537ZM66.078 57.3932L69.9935 59.6711L70.8852 59.1569L66.9697 56.879L66.078 57.3932ZM62.1987 59.8921L67.8162 63.1488L68.7079 62.6346L63.0904 59.3779L62.1987 59.8921ZM62.9637 57.948L69.061 61.4979L69.9527 60.9837L63.8554 57.4338L62.9637 57.948ZM43.4043 46.6895L45.1969 47.7179L46.0886 47.2037L44.2961 46.1753L43.4043 46.6895ZM48.2116 50.7942L47.1116 50.1582L46.2199 50.6724L47.3198 51.3084L48.2116 50.7942ZM49.2074 49.0035L46.8174 47.6277L45.9256 48.1419L48.3157 49.5177L49.2074 49.0035ZM54.4899 52.0436L49.9453 49.4275L49.0535 49.9417L53.5982 52.5578L54.4899 52.0436ZM58.9713 59.3689L52.1271 55.4086L51.2353 55.9228L58.0795 59.8831L58.9713 59.3689ZM46.5594 46.1437L51.5205 48.999L52.4122 48.4847L47.4511 45.6295L46.5594 46.1437ZM58.6363 53.0901L65.3401 56.9692L66.2319 56.455L59.528 52.5759L58.6363 53.0901ZM59.0346 62.797L59.9264 62.2827L55.1282 59.4997L54.2364 60.0139L59.0346 62.797ZM67.9384 64.5561L59.7046 59.7929L58.8128 60.3071L67.0467 65.0703L67.9384 64.5561ZM58.7947 52.1564L54.9833 49.9642L54.0916 50.4784L57.903 52.6706L58.7947 52.1564ZM47.4421 52.7157L43.5854 50.4965L42.6937 51.0107L46.5503 53.2299L47.4421 52.7157ZM57.7491 53.92L55.2232 52.4676L54.3315 52.9818L56.8573 54.4343L57.7491 53.92ZM42.8476 50.0725L40.4575 48.6967L39.5658 49.211L41.9558 50.5867L42.8476 50.0725ZM40.5209 47.3932L45.482 50.2484L46.3738 49.7342L41.4126 46.879L40.5209 47.3932ZM44.1467 53.1848L39.1856 50.3296L38.2938 50.8438L43.255 53.699L44.1467 53.1848ZM52.7563 53.4103L48.9449 51.2182L48.0531 51.7324L51.8645 53.9246L52.7563 53.4103ZM54.3904 59.0757L51.267 57.2805L50.3753 57.7947L53.4986 59.5899L54.3904 59.0757ZM48.6461 59.1569L49.8411 59.8425L50.7329 59.3283L49.5379 58.6427L48.6461 59.1569ZM50.5744 60.2665L53.8336 62.1429L54.7253 61.6287L51.4662 59.7523L50.5744 60.2665ZM45.8306 55.174L49.642 57.3662L50.5337 56.852L46.7223 54.6598L45.8306 55.174ZM40.2403 54.3215L42.6303 55.6972L43.522 55.183L41.132 53.8073L40.2403 54.3215ZM51.3938 54.9891L48.1799 53.1397L47.2881 53.6539L50.502 55.5033L51.3938 54.9891ZM43.9928 54.1185L45.0928 54.7545L45.9845 54.2403L44.88 53.6043L43.9928 54.1185ZM76.1677 62.197L75.276 62.7113L79.0466 64.8448L79.9384 64.3306L76.1677 62.197ZM72.0667 65.589L74.9456 67.2083L75.8373 66.6941L72.9584 65.0748L72.0667 65.589ZM67.8524 65.5304L72.886 68.3901L73.7777 67.8759L68.7441 65.0162L67.8524 65.5304ZM67.015 67.4113L70.7856 69.5448L71.6774 69.0306L67.9067 66.8971L67.015 67.4113ZM59.7679 63.2164L66.2772 66.9873L67.1689 66.4731L60.6597 62.7067L59.7679 63.2164ZM43.3636 56.1167L47.9083 58.7329L48.8 58.2187L44.2553 55.6025L43.3636 56.1167ZM46.7133 45.2055L41.8065 42.3774L40.9147 42.8916L45.8215 45.7197L46.7133 45.2055ZM70.7313 60.0951L74.5427 62.2873L75.4344 61.773L71.623 59.5809L70.7313 60.0951ZM52.2538 49.4184L53.3538 50.0544L54.2455 49.5402L53.141 48.9042L52.2538 49.4184ZM77.8154 65.4763L70.5503 61.331L69.6585 61.8452L76.9237 65.9905L77.8154 65.4763ZM72.3745 64.7455L69.4412 63.0586L68.5495 63.5728L71.4827 65.2597L72.3745 64.7455ZM62.3571 58.9539L57.3507 56.0491L56.459 56.5633L61.4654 59.4681L62.3571 58.9539ZM43.5582 45.7558L39.7514 43.5591L38.8597 44.0734L42.6665 46.27L43.5582 45.7558ZM30.6484 48.796L36.9811 52.4451L37.8729 51.9309L31.5402 48.2818L30.6484 48.796ZM38.4523 49.9056L33.5907 47.1045L32.699 47.6187L37.5605 50.4198L38.4523 49.9056ZM39.7288 48.2773L35.6458 45.9227L34.754 46.4369L38.8325 48.7915L39.7288 48.2773ZM40.6793 46.4595L37.7009 44.7409L36.8091 45.2551L39.7876 46.9737L40.6793 46.4595ZM37.7144 52.8691L39.507 53.8975L40.3987 53.3833L38.6062 52.3549L37.7144 52.8691Z",
    fill: "#E5D4EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.094 37.2532L118.656 39.8783C118.847 39.9866 119.15 39.9866 119.335 39.8783C119.521 39.7701 119.521 39.5942 119.335 39.4859L114.773 36.8607C114.583 36.7525 114.279 36.7525 114.094 36.8607C113.904 36.969 113.904 37.1449 114.094 37.2532ZM118.19 40.149L113.627 37.5238C113.437 37.4155 113.134 37.4155 112.948 37.5238C112.763 37.632 112.763 37.808 112.948 37.9162L117.511 40.5414C117.701 40.6497 118.005 40.6497 118.19 40.5414C118.38 40.4331 118.38 40.2572 118.19 40.149ZM117.045 40.8075L112.482 38.1823C112.292 38.0741 111.989 38.0741 111.803 38.1823C111.618 38.2906 111.618 38.4665 111.803 38.5748L116.366 41.1999C116.556 41.3082 116.859 41.3082 117.045 41.1999C117.235 41.0917 117.235 40.9158 117.045 40.8075Z",
    fill: "#E5D4EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.4375 41.0286L90.1776 58.6516L114.069 44.9077L83.4375 41.0286Z",
    fill: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.4451 58.5613L82.7095 40.9383L52.0781 37.0637L89.4451 58.5613Z",
    fill: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.2746 40.6137L113.906 44.4883L76.5391 22.9907L83.2746 40.6137Z",
    fill: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9219 36.6443L82.5487 40.5189L75.8132 22.9004L51.9219 36.6443Z",
    fill: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.2527 23.0041L87.8943 24.3618L85.5178 22.9951L83.7344 24.019L87.9034 26.4187L92.0452 24.0326L90.2527 23.0041Z",
    fill: "#E5D4EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.888 23.8386L89.7982 22.7426L87.879 21.6375L85.9688 22.7335L87.888 23.8386Z",
    fill: "#E5D4EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.8744 21.1186L92.4915 23.7754L94.4968 22.6207L87.8609 18.8047L81.2656 22.5981L83.2845 23.7619L87.8744 21.1186Z",
    fill: "#E5D4EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4367 61.0557L9.65625 61.0242L27.491 71.2813L27.4367 61.0557Z",
    fill: "#E5D4EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0469 50.4468L28.1012 60.6724L45.8816 60.7039L28.0469 50.4468Z",
    fill: "#E5D4EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4367 60.6725L27.3778 50.4424L9.65625 60.6409L27.4367 60.6725Z",
    fill: "#E5D4EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8853 61.0872L28.1094 61.0557L28.1637 71.2858L45.8853 61.0872Z",
    fill: "#E5D4EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.296 72.5399L29.5156 72.5083L47.3504 82.77L47.296 72.5399Z",
    fill: "#E5D4EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.8984 61.9309L47.9528 72.161L65.7332 72.1926L47.8984 61.9309Z",
    fill: "#E5D4EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.296 72.1565L47.2372 61.9309L29.5156 72.1249L47.296 72.1565Z",
    fill: "#E5D4EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7368 72.5714L47.9609 72.5398L48.0153 82.7699L65.7368 72.5714Z",
    fill: "#E5D4EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.9169 45.2235L65.78 36.5135C64.2545 35.6339 64.4446 34.1003 66.21 33.0854C67.9754 32.0705 70.6415 31.9623 72.167 32.8373L87.3039 41.5473C88.8293 42.4269 88.6392 43.9605 86.8738 44.9754C85.113 45.9903 82.4469 46.1031 80.9169 45.2235Z",
    fill: "url(#paint48_linear_2164_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.6764 40.9655L80.2781 39.6393L79.6398 40.0047L75.5478 37.6501L74.9141 38.0155L79.0061 40.3701L78.3724 40.7354L80.6764 40.9655Z",
    fill: "#EBDEF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.0517 43.1981L85.0291 43.1846L85.622 42.8418C86.0023 42.6208 86.0023 42.2644 85.6175 42.0479L85.1377 41.7728C84.7529 41.5518 84.1373 41.5518 83.7526 41.7683L83.1596 42.1111L83.1369 42.0975C82.9604 41.9938 82.6707 41.9938 82.4942 42.0975L81.023 42.941C80.8465 43.0448 80.8465 43.2072 81.023 43.3109L82.9378 44.4115C83.1143 44.5152 83.404 44.5152 83.5805 44.4115L85.0562 43.5635C85.2327 43.4643 85.2282 43.3019 85.0517 43.1981ZM82.983 43.4237L82.6345 43.6221L82.3946 43.4823L82.7431 43.2838C82.6933 43.2026 82.7205 43.1079 82.8337 43.0448C82.9876 42.9546 83.2365 42.9546 83.395 43.0448C83.5489 43.135 83.5489 43.2793 83.395 43.365C83.2863 43.4372 83.1234 43.4552 82.983 43.4237ZM84.6262 42.9501L83.567 42.3411L84.0423 42.066C84.2595 41.9397 84.6126 41.9442 84.8299 42.066L85.1015 42.2238C85.3187 42.3501 85.3188 42.5531 85.106 42.6749L84.6262 42.9501Z",
    fill: "#EBDEF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9718 71.7775C62.5192 71.5158 61.8764 71.4392 61.306 71.5384C61.4826 71.2136 61.3423 70.8392 60.8941 70.5821C60.2468 70.2078 59.2012 70.2078 58.5584 70.5776C57.3815 71.2542 58.1374 73.3607 58.1374 73.3607C58.1374 73.3607 61.804 73.7982 62.9764 73.1216C63.6237 72.7517 63.6191 72.1518 62.9718 71.7775Z",
    fill: "url(#paint49_linear_2164_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3525 73.911L2.60156 53.3426L41.847 30.7444L77.598 51.3128L38.3525 73.911Z",
    fill: "url(#paint50_linear_2164_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.887 54.5786L36.1406 34.0102L43.4692 29.8108L79.2201 50.3792L71.887 54.5786Z",
    fill: "url(#paint51_linear_2164_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.4619 57.231L31.1172 42.0753L36.617 38.999L62.9617 54.1547L57.4619 57.231Z",
    fill: "#EBDEF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6839 61.7776L23.3438 46.6219L28.8435 43.5457L55.1882 58.7013L49.6839 61.7776Z",
    fill: "#EBDEF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5661 68.4217L22.9185 60.5687C21.5922 59.8064 21.7597 58.4758 23.2896 57.5962C24.8196 56.7166 27.1327 56.6219 28.459 57.3842L42.1066 65.2372C43.4329 65.9995 43.2654 67.3301 41.7355 68.2097C40.2055 69.0893 37.8924 69.184 36.5661 68.4217Z",
    fill: "url(#paint52_linear_2164_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8745 66.3875L15.4141 47.1362L15.7219 47.0054L49.1824 66.2567L48.8745 66.3875Z",
    fill: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M71.823 50.2214L73.6562 50.226C73.8146 50.226 73.9459 50.1538 73.9414 50.0591C73.9414 49.9689 73.8101 49.8922 73.6517 49.8922L71.8184 49.8877L71.8139 48.8322C71.8139 48.742 71.6826 48.6653 71.5242 48.6653C71.3658 48.6653 71.2345 48.7375 71.239 48.8322L71.2436 49.8877L69.4103 49.8831C69.2519 49.8831 69.1206 49.9553 69.1251 50.05C69.1251 50.0952 69.1568 50.1357 69.2111 50.1673C69.2654 50.1989 69.3333 50.2169 69.4148 50.2169L71.2481 50.2214L71.2526 51.2769C71.2526 51.322 71.2843 51.3626 71.3386 51.3942C71.3929 51.4258 71.4608 51.4438 71.5423 51.4438C71.7007 51.4438 71.832 51.3717 71.8275 51.2769L71.823 50.2214Z",
    fill: "#EBDEF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3525 73.5322L3.15381 53.0269L2.60156 53.3427L38.3525 73.9111L79.146 50.3837L78.5938 50.3206L38.3525 73.5322Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M35.9609 64.6599L35.5626 63.3338L34.9289 63.7037L30.8368 61.3491L30.2031 61.71L34.2952 64.0645L33.6569 64.4344L35.9609 64.6599Z",
    fill: "#EBDEF3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M39.5671 66.3604L38.5622 66.9377L37.5528 66.3604L36.7969 66.7934L38.5668 67.8128L40.3276 66.7979L39.5671 66.3604Z",
    fill: "#EBDEF3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M38.5648 66.7167L39.375 66.2521L38.5603 65.783L37.75 66.2476L38.5648 66.7167Z",
    fill: "#EBDEF3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M38.552 65.5619L40.5165 66.6896L41.3675 66.1979L38.5474 64.5786L35.75 66.1889L36.6055 66.6851L38.552 65.5619Z",
    fill: "#EBDEF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2464 43.1804C37.097 43.0405 37.011 42.8782 37.0065 42.7203C37.0019 42.6256 37.1423 42.5489 37.3097 42.5489C37.527 42.5489 37.7534 42.5263 37.9616 42.4767C38.0747 42.5173 38.2739 42.5308 38.3825 42.4677C38.4912 42.4045 38.5274 42.3188 38.4776 42.2602C38.9167 41.9806 39.1204 41.6513 38.4957 41.2904C37.871 40.9296 37.2916 41.0468 36.8073 41.2994C36.7077 41.2679 36.5629 41.2904 36.4497 41.3536C36.3411 41.4167 36.3682 41.5295 36.4361 41.5971C36.3501 41.7189 36.3139 41.8497 36.3139 41.9715C36.3139 42.0663 36.1781 42.1474 36.0106 42.1474C35.7345 42.1429 35.4584 42.0978 35.2139 42.0076C34.888 41.8903 34.458 41.9129 34.1774 42.0753L33.6885 42.3549C33.5934 42.4091 33.5934 42.4993 33.6885 42.5534L36.2958 44.0509C36.3909 44.1051 36.5448 44.1051 36.6398 44.0509L37.1287 43.7713C37.4048 43.6179 37.4455 43.3698 37.2464 43.1804Z",
    fill: "#C4B0D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5439 47.109L30.5212 47.0955L31.1142 46.7527C31.4945 46.5317 31.4945 46.1753 31.1097 45.9588L30.6299 45.6837C30.2451 45.4626 29.6295 45.4626 29.2447 45.6792L28.6518 46.022L28.6337 46.0084C28.4571 45.9047 28.1674 45.9047 27.9909 46.0084L26.5152 46.8564C26.3387 46.9602 26.3387 47.1226 26.5152 47.2263L28.43 48.3269C28.6065 48.4306 28.8962 48.4306 29.0727 48.3269L30.5484 47.4789C30.7249 47.3797 30.7249 47.2128 30.5439 47.109ZM28.4752 47.3391L28.1267 47.5375L27.8868 47.3977L28.2353 47.1992C28.1855 47.118 28.2127 47.0233 28.3258 46.9602C28.4798 46.87 28.7287 46.87 28.8871 46.9602C29.041 47.0504 29.041 47.1947 28.8871 47.2804C28.7785 47.3526 28.6155 47.3661 28.4752 47.3391ZM30.1184 46.8655L29.0592 46.2565L29.5344 45.9814C29.7517 45.8551 30.1048 45.8596 30.3221 45.9814L30.5937 46.1392C30.8109 46.2655 30.8109 46.4685 30.5982 46.5903L30.1184 46.8655Z",
    fill: "#C4B0D1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M98.2999 42.445L69.3071 25.4941C67.5056 24.4567 67.501 21.8676 69.2981 20.8256L70.7783 19.9912C71.6157 19.504 72.6523 19.504 73.4942 19.9867L102.487 36.9331C104.289 37.9705 104.293 40.5596 102.496 41.6016L101.016 42.436C100.174 42.9232 99.1418 42.9277 98.2999 42.445Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.2287 43.3335L61.4453 21.457L74.4502 14.001L112.229 35.8775L99.2287 43.3335Z",
    fill: "url(#paint53_linear_2164_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.2287 42.8781L62.1062 21.0737L61.4453 21.4571L99.2287 43.3336L112.202 35.8866L111.541 35.8099L99.2287 42.8781Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.9109 38.8861L69.3203 21.2496L74.8201 18.1733L105.411 35.8099L99.9109 38.8861Z",
    fill: "#EBDEF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.493 37.6862L100.489 36.6623C100.489 36.554 100.362 36.4638 100.19 36.4367V36.139C101.095 36.0669 101.792 35.6248 101.788 35.0835C101.783 34.4926 100.95 34.01 99.9184 34.01C98.8909 34.01 98.058 34.4881 98.0625 35.079C98.067 35.6203 98.7687 36.0669 99.674 36.1435V36.4412C99.502 36.4683 99.3752 36.5585 99.3752 36.6623L99.3798 37.6862C99.3798 37.8125 99.5608 37.9207 99.7826 37.9207H100.086C100.312 37.9162 100.493 37.8125 100.493 37.6862ZM99.9275 35.7827C99.2485 35.7827 98.7008 35.4624 98.6962 35.0745C98.6917 34.6866 99.2394 34.3709 99.9184 34.3709C100.597 34.3709 101.145 34.6911 101.15 35.079C101.154 35.4669 100.606 35.7827 99.9275 35.7827Z",
    fill: "#C4B0D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.0663 13.4913L86.2994 10.176L81.9766 12.6614L92.0935 18.4846L102.152 12.702L97.797 10.1941L92.0663 13.4913Z",
    fill: "url(#paint54_linear_2164_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.0291 6.87866L87.3984 9.54444L92.0608 12.2237L96.6915 9.55797L92.0291 6.87866Z",
    fill: "url(#paint55_linear_2164_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.9916 0L75.9766 9.2152L80.8788 12.0343L92.0233 5.62023L103.236 12.0749L108.106 9.26933L91.9916 0Z",
    fill: "url(#paint56_linear_2164_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.0935 18.0335L82.3658 12.4358L81.9766 12.6613L92.0935 18.4845L102.152 12.7019L101.758 12.4764L92.0935 18.0335Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.236 11.6239L92.0233 5.16919L80.8788 11.5833L76.3704 8.98969L75.9766 9.21522L80.8788 12.0344L92.0233 5.62025L103.236 12.075L108.106 9.26934L107.717 9.04381L103.236 11.6239Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.0608 12.2237L96.6915 9.55791L96.2977 9.33238L92.0608 11.7726L87.7922 9.31885L87.3984 9.54438L92.0608 12.2237Z",
    fill: "#231F20"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2164_1266",
    x1: 66.4996,
    y1: 65.2565,
    x2: 66.4996,
    y2: 81.6151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#6B24D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316,
    stopColor: "#7A1CD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8574,
    stopColor: "#A306C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9848,
    stopColor: "#AD00BD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2164_1266",
    x1: 65.92,
    y1: 63.2002,
    x2: 64.6244,
    y2: 83.1655,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#6B24D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316,
    stopColor: "#7A1CD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8574,
    stopColor: "#A306C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9848,
    stopColor: "#AD00BD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2164_1266",
    x1: 65.628,
    y1: 60.9205,
    x2: 62.5469,
    y2: 84.5583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#6B24D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316,
    stopColor: "#7A1CD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8574,
    stopColor: "#A306C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9848,
    stopColor: "#AD00BD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2164_1266",
    x1: 65.6671,
    y1: 58.467,
    x2: 60.292,
    y2: 85.7632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#6B24D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316,
    stopColor: "#7A1CD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8574,
    stopColor: "#A306C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9848,
    stopColor: "#AD00BD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2164_1266",
    x1: 66.0571,
    y1: 55.8947,
    x2: 57.8734,
    y2: 86.7502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#6B24D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316,
    stopColor: "#7A1CD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8574,
    stopColor: "#A306C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9848,
    stopColor: "#AD00BD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2164_1266",
    x1: 66.819,
    y1: 53.2646,
    x2: 55.3206,
    y2: 87.4919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#6B24D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316,
    stopColor: "#7A1CD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8574,
    stopColor: "#A306C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9848,
    stopColor: "#AD00BD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2164_1266",
    x1: 67.961,
    y1: 50.6413,
    x2: 52.6646,
    y2: 87.9642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#6B24D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316,
    stopColor: "#7A1CD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8574,
    stopColor: "#A306C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9848,
    stopColor: "#AD00BD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2164_1266",
    x1: 69.4713,
    y1: 48.0922,
    x2: 49.9321,
    y2: 88.1479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#6B24D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316,
    stopColor: "#7A1CD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8574,
    stopColor: "#A306C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9848,
    stopColor: "#AD00BD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2164_1266",
    x1: 71.4587,
    y1: 45.4953,
    x2: 47.1925,
    y2: 88.0008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#6B24D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316,
    stopColor: "#7A1CD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8574,
    stopColor: "#A306C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9848,
    stopColor: "#AD00BD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2164_1266",
    x1: 74.1231,
    y1: 42.6405,
    x2: 43.3553,
    y2: 89.2279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#6B24D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316,
    stopColor: "#7A1CD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8574,
    stopColor: "#A306C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9848,
    stopColor: "#AD00BD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2164_1266",
    x1: 77.3081,
    y1: 39.9283,
    x2: 39.2431,
    y2: 90.1428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#6B24D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316,
    stopColor: "#7A1CD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8574,
    stopColor: "#A306C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9848,
    stopColor: "#AD00BD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2164_1266",
    x1: 81.0234,
    y1: 37.416,
    x2: 34.9686,
    y2: 90.6069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#6B24D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316,
    stopColor: "#7A1CD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8574,
    stopColor: "#A306C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9848,
    stopColor: "#AD00BD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2164_1266",
    x1: 85.2364,
    y1: 35.201,
    x2: 30.5918,
    y2: 90.5899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#6B24D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316,
    stopColor: "#7A1CD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8574,
    stopColor: "#A306C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9848,
    stopColor: "#AD00BD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2164_1266",
    x1: 89.8973,
    y1: 33.3759,
    x2: 26.1764,
    y2: 90.0706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#6B24D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316,
    stopColor: "#7A1CD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8574,
    stopColor: "#A306C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9848,
    stopColor: "#AD00BD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2164_1266",
    x1: 94.9398,
    y1: 32.0221,
    x2: 21.7894,
    y2: 89.0341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#6B24D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316,
    stopColor: "#7A1CD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8574,
    stopColor: "#A306C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9848,
    stopColor: "#AD00BD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2164_1266",
    x1: 100.282,
    y1: 31.2088,
    x2: 17.498,
    y2: 87.4732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#6B24D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316,
    stopColor: "#7A1CD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8574,
    stopColor: "#A306C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9848,
    stopColor: "#AD00BD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2164_1266",
    x1: 105.828,
    y1: 30.9811,
    x2: 13.3669,
    y2: 85.3799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#6B24D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316,
    stopColor: "#7A1CD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8574,
    stopColor: "#A306C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9848,
    stopColor: "#AD00BD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2164_1266",
    x1: 111.474,
    y1: 31.3646,
    x2: 9.46541,
    y2: 82.7519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#6B24D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316,
    stopColor: "#7A1CD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8574,
    stopColor: "#A306C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9848,
    stopColor: "#AD00BD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2164_1266",
    x1: 117.123,
    y1: 32.4196,
    x2: 5.87107,
    y2: 79.6485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#6B24D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316,
    stopColor: "#7A1CD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8574,
    stopColor: "#A306C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9848,
    stopColor: "#AD00BD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2164_1266",
    x1: 122.686,
    y1: 34.1605,
    x2: 2.67026,
    y2: 76.1102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#6B24D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316,
    stopColor: "#7A1CD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8574,
    stopColor: "#A306C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9848,
    stopColor: "#AD00BD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2164_1266",
    x1: 128.044,
    y1: 36.5815,
    x2: -0.0829817,
    y2: 72.1851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#6B24D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316,
    stopColor: "#7A1CD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8574,
    stopColor: "#A306C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9848,
    stopColor: "#AD00BD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2164_1266",
    x1: 133.085,
    y1: 39.663,
    x2: -2.33328,
    y2: 67.9323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#6B24D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316,
    stopColor: "#7A1CD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8574,
    stopColor: "#A306C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9848,
    stopColor: "#AD00BD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_2164_1266",
    x1: 132.527,
    y1: 40.6809,
    x2: -2.93449,
    y2: 67.1726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#6B24D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316,
    stopColor: "#7A1CD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8574,
    stopColor: "#A306C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9848,
    stopColor: "#AD00BD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_2164_1266",
    x1: 132.465,
    y1: 40.5562,
    x2: -2.93164,
    y2: 67.0352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#702AD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3311,
    stopColor: "#7F22D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9017,
    stopColor: "#A80CC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9848,
    stopColor: "#AE08BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_2164_1266",
    x1: 132.423,
    y1: 40.4283,
    x2: -2.92696,
    y2: 66.8981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#7430D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3393,
    stopColor: "#8328D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9258,
    stopColor: "#AC12C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9848,
    stopColor: "#B010C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_2164_1266",
    x1: 132.386,
    y1: 40.2996,
    x2: -2.92368,
    y2: 66.7617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#7937D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3574,
    stopColor: "#882ED2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9789,
    stopColor: "#B118C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9848,
    stopColor: "#B118C2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_2164_1266",
    x1: 132.35,
    y1: 40.1706,
    x2: -2.92215,
    y2: 66.6253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#7D3DD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3673,
    stopColor: "#8C35D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9848,
    stopColor: "#B320C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_2164_1266",
    x1: 132.319,
    y1: 40.0414,
    x2: -2.91685,
    y2: 66.489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#8243D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3894,
    stopColor: "#913BD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9848,
    stopColor: "#B428C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_2164_1266",
    x1: 132.285,
    y1: 39.912,
    x2: -2.9151,
    y2: 66.3526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#8649DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4017,
    stopColor: "#9541D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9848,
    stopColor: "#B62FC8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_2164_1266",
    x1: 132.252,
    y1: 39.7828,
    x2: -2.91359,
    y2: 66.2166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#8B4FDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4294,
    stopColor: "#9A47D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9848,
    stopColor: "#B737CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_2164_1266",
    x1: 132.212,
    y1: 39.653,
    x2: -2.92001,
    y2: 66.0802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#9056DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.462,
    stopColor: "#9F4DD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9848,
    stopColor: "#B83FCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_2164_1266",
    x1: 132.184,
    y1: 39.5232,
    x2: -2.9156,
    y2: 65.9442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#945CDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4807,
    stopColor: "#A353D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9848,
    stopColor: "#BA47CD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_2164_1266",
    x1: 132.155,
    y1: 39.3931,
    x2: -2.9145,
    y2: 65.8081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#9962DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5233,
    stopColor: "#A859D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9848,
    stopColor: "#BB4FCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_2164_1266",
    x1: 132.128,
    y1: 39.2626,
    x2: -2.91351,
    y2: 65.6722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#9D68DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5488,
    stopColor: "#AC60D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9848,
    stopColor: "#BD57D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_2164_1266",
    x1: 132.099,
    y1: 39.1314,
    x2: -2.91722,
    y2: 65.536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#A26EDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6096,
    stopColor: "#B166D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9848,
    stopColor: "#BE5FD3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_2164_1266",
    x1: 132.077,
    y1: 39,
    x2: -2.91653,
    y2: 65.4002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#A674DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6464,
    stopColor: "#B56CD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9848,
    stopColor: "#C067D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_2164_1266",
    x1: 132.058,
    y1: 38.8678,
    x2: -2.91572,
    y2: 65.2641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#AB7BDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7383,
    stopColor: "#BA73D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9848,
    stopColor: "#C16FD6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_2164_1266",
    x1: 132.043,
    y1: 38.7352,
    x2: -2.91388,
    y2: 65.1282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#B081DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867,
    stopColor: "#BF78D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9848,
    stopColor: "#C277D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_2164_1266",
    x1: 132.025,
    y1: 38.6021,
    x2: -2.91782,
    y2: 64.9923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#B487E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9534,
    stopColor: "#C37EDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9848,
    stopColor: "#C47EDA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_2164_1266",
    x1: 132.015,
    y1: 38.4684,
    x2: -2.91708,
    y2: 64.8565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#B98DE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9848,
    stopColor: "#C586DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_2164_1266",
    x1: 132,
    y1: 38.3341,
    x2: -2.92298,
    y2: 64.7205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#BD93E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9848,
    stopColor: "#C78EDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_2164_1266",
    x1: 131.995,
    y1: 38.1996,
    x2: -2.92234,
    y2: 64.5848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#C29AE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9848,
    stopColor: "#C896DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_2164_1266",
    x1: 131.994,
    y1: 38.0645,
    x2: -2.91847,
    y2: 64.4489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#C6A0E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9848,
    stopColor: "#CA9EE1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_2164_1266",
    x1: 116.663,
    y1: 53.36,
    x2: 114.976,
    y2: 49.6343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#6B24D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316,
    stopColor: "#7A1CD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8574,
    stopColor: "#A306C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9848,
    stopColor: "#AD00BD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_2164_1266",
    x1: 114.985,
    y1: 75.5718,
    x2: 118.018,
    y2: 78.2808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#B081DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867,
    stopColor: "#BF78D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9848,
    stopColor: "#C277D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_2164_1266",
    x1: 110.068,
    y1: 58.9493,
    x2: 107.65,
    y2: 52.9667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#6B24D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316,
    stopColor: "#7A1CD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8574,
    stopColor: "#A306C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9848,
    stopColor: "#AD00BD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_2164_1266",
    x1: 107.761,
    y1: 83.6589,
    x2: 110.794,
    y2: 86.3681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#B081DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867,
    stopColor: "#BF78D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9848,
    stopColor: "#C277D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_2164_1266",
    x1: 87.7702,
    y1: 16.7516,
    x2: 24.6567,
    y2: 116.058,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5D4EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_2164_1266",
    x1: 79.3104,
    y1: 24.625,
    x2: 73.4517,
    y2: 55.3418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#6B24D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316,
    stopColor: "#7A1CD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8574,
    stopColor: "#A306C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9848,
    stopColor: "#AD00BD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_2164_1266",
    x1: 57.0779,
    y1: 63.8957,
    x2: 62.8521,
    y2: 77.893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#6B24D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316,
    stopColor: "#7A1CD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8574,
    stopColor: "#A306C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9848,
    stopColor: "#AD00BD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_2164_1266",
    x1: 12.4041,
    y1: 0.153211,
    x2: 70.5496,
    y2: 110.467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#6B24D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316,
    stopColor: "#7A1CD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8574,
    stopColor: "#A306C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9848,
    stopColor: "#AD00BD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_2164_1266",
    x1: 57.8985,
    y1: 24.5012,
    x2: 57.3044,
    y2: 72.7932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D085D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#410F82"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_2164_1266",
    x1: 33.3707,
    y1: 44.5743,
    x2: 31.6077,
    y2: 82.4878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D085D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#410F82"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_2164_1266",
    x1: 51.2368,
    y1: 8.18312,
    x2: 80.2156,
    y2: 58.5492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D085D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#410F82"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_2164_1266",
    x1: 81.9759,
    y1: 14.3301,
    x2: 102.151,
    y2: 14.3301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2438,
    stopColor: "#AE25B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6455,
    stopColor: "#D744BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF63CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_2164_1266",
    x1: 79.4441,
    y1: 9.22252,
    x2: 96.7582,
    y2: 9.67677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2438,
    stopColor: "#AE25B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6455,
    stopColor: "#D744BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF63CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_2164_1266",
    x1: 75.9774,
    y1: 6.03697,
    x2: 108.108,
    y2: 6.03697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2438,
    stopColor: "#AE25B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6455,
    stopColor: "#D744BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF63CE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2164_1266"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 133,
    height: 93,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.a0780c8e73cb3558eb54eeb8759e36fb.svg";
export { ForwardRef as ReactComponent };